<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">STUDENTS LIST</h4>
             
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
         <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Father Name</th>
                            <th>Email</th>
                            <th>Number</th>
                            <th>Show</th>
                            <th>Edit</th>
                          <th>Delete</th>
                            
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer.name}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.father_name}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.email }} 
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.number}}
                            </td>
                         

                            <td><a data-toggle="modal" data-target="#showCM" class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                                <td><button data-toggle="modal" data-target="#showCM" [disabled]="customer.status=='cancel'"
                                    class="btn btn-primary btn-circle btn-sm" (click)="buttonviewmeeting(customer,'edit')">
                                    <i class="fas fa-check"></i>
                                </button></td>
                            <td><a class="btn btn-danger btn-circle btn-sm" (click)="delete_student(customer.id)">
                                <i class="fas fa-times"></i>
                                                            </a></td>
                            <ng-template #notShow>
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div> 
       

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">

                </div>
            </div>
        </div>



        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card-primary ">
                        <div class="card-header newcolor1">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,Student_id)" autocomplete="off">
                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Name </label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control" [value]="Student_name"
                                            formControlName="name" placeholder="Enter Name">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Father Name </label><span class="required "> *</span>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="Student_father_name" formControlName="name"
                                            placeholder="Enter  Father Name ">

                                    </div>
                                </div> -->
                        

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Name  <span class="pull-right"> :</span></h6>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Student_name    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Father Name  <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Student_father_name  }}</h6>
                            </div>
                        </div>

                                </div>
                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Date of Birth </label><span class="required "> *</span>
                                        <input readonly pInputText type="date" class="form-control" [value]="Student_DOB"
                                            formControlName="name" placeholder="Enter Date of Birth ">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email<span class="required "> *</span></label>
                                        <input readonly pInputText type="email" class="form-control" [value]="Student_email"
                                            formControlName="name" placeholder="Enter Email">

                                    </div>
                                </div> -->
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Date of Birth  <span class="pull-right"> :</span></h6>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     Student_DOB   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Email <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Student_email  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row" >
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> WhatsApp Number <span class="pull-right"> :</span></h6>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     Student_number   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6 " >
                                    <h6 class="f-w-500">Parents WhatsApp Number <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6 classic1"><h6>{{
                                 Student_parent_number  }}</h6>
                            </div>
                        </div>

                                </div>
                               
                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Course/Grade<span class="required ">*</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="Student_grade"
                                            formControlName="grade" placeholder="Enter Course/Grade"
                                            required>

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Institute Name <span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control"
                                            [value]="Student_college_name" formControlName="college_name"
                                            placeholder="Enter Institute Name">
                                    </div>
                                </div> -->
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Course/Grade <span class="pull-right"> :</span></h6>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     Student_grade   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Institute Name  <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Student_college_name  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> District <span class="pull-right"> :</span></h6>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     Student_district   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Subjects Coaching Required   <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6 classic1"><h6>{{
                                 Student_subject  }}</h6>
                            </div>
                        </div>

                                </div>
                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District <span class="required">
                                                *</span></label><br>
                                        <input readonly [value]="Student_district" pInputText type="text"
                                            class="form-control" formControlName="district"
                                            placeholder="Enter District / மாவட்டம்" required>
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Subjects Coaching Required <span
                                                class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="Student_subject"
                                            formControlName="subject"
                                            placeholder="Enter Subjects Coaching Required / பாடங்கள் பயிற்சி தேவை">
                                    </div>
                                </div> -->
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="Student_image !=='' && !editfield">
                                        <label>Image <span class="required "> </span></label>
                                        <img src="https://myroots.redmindtechnologies.com/api/{{Student_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="Student_name"
                                            formControlName="name" placeholder="Enter Name / பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Father Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="Student_father_name"
                                            formControlName="father_name" placeholder="Enter  Father Name /தந்தை பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Date of Birth </label><span class="required "> *</span>
                                        <input pInputText type="date" class="form-control" [value]="Student_DOB"
                                            formControlName="DOB" placeholder="Enter Date of Birth / பிறந்த நாள்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email <span class="required "> *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="Student_email"
                                            formControlName="email" placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>WhatsApp Number <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" [value]="Student_number"
                                            formControlName="number" placeholder="Enter Date of Birth / பிறந்த நாள்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Parents WhatsApp Number<span class="required ">
                                                *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="Student_parent_number"
                                            formControlName="parent_number"
                                            placeholder="Enter Parents WhatsApp Number/பெற்றோர் வாட்ஸ்அப் எண்">

                                    </div>
                                </div>


                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>School Grade<span class="required ">*</span></label>
                                        <input pInputText type="text" class="form-control" [value]="Student_grade"
                                            formControlName="grade" placeholder="Enter School Grade/கல்லூரி தரம்"
                                            required>

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>School Name<span class="required ">
                                                *</span></label>
                                        <input pInputText type="text" class="form-control" [value]="Student_college_name"
                                            formControlName="college_name"
                                            placeholder="Enter School Name/கல்லூரியின் பெயர்">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District <span class="required ">
                                                *</span></label><br>
                                        <select class="form-control" formControlName="district" [(ngModel)]="district"
                                            #mydst (change)="getChangeToConstituey(mydst.value)">
                                            <option value="" selected disabled hidden>Select District</option>
                                            <option *ngFor="let option of district_list" [ngValue]="option">
                                                {{option}}</option>
                                        </select>

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Subjects Coaching Required <span
                                                class="required ">
                                                *</span></label>
                                        <input pInputText type="text" class="form-control" [value]="Student_subject"
                                            formControlName="subject"
                                            placeholder="Enter Subjects Coaching Required / பாடங்கள் பயிற்சி தேவை">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="Student_image !==''&& editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://myroots.redmindtechnologies.com/api/{{Student_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                    <div class="col-md-6" *ngIf="editfield">
                                        <label>Photo<span class="required">*</span></label>
                                        <input type="file" class="form-control" formControlName="image"
                                            (change)="selectFiles($event)" />
                                    </div>
                                </div>



                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary tn btn-block">Update </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>